"use client";

import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { ConfigProvider, theme } from "antd";
import { useTheme } from "next-themes";

export default function AntdThemeSwitcher({
  children,
}: {
  children: ReactNode;
}) {
  const { theme: nextTheme } = useTheme();
  const [mnt, setMnt] = useState<boolean>(false);

  const antdTheme = useMemo(
    () => (nextTheme === "dark" ? theme.darkAlgorithm : theme.defaultAlgorithm),
    [nextTheme]
  );

  const token = useMemo(
    () =>
      nextTheme === "dark"
        ? {
            colorPrimary: "#6f9dff",
            colorInfo: "#6f9dff",
            borderRadius: 12,
            colorBgContainer: "#111c30",
            colorBgElevated: "#15223b",
            colorBorder: "rgba(190, 210, 240, 0.2)",
            colorText: "#eff5ff",
            colorTextSecondary: "#9db0cc",
          }
        : {
            colorPrimary: "#2f6df6",
            colorInfo: "#2f6df6",
            borderRadius: 12,
            colorBgContainer: "#ffffff",
            colorBgElevated: "#f7faff",
            colorBorder: "rgba(16, 35, 59, 0.12)",
            colorText: "#10233b",
            colorTextSecondary: "#5e6f89",
          },
    [nextTheme]
  );

  useEffect(() => {
    setMnt(true);
  }, []);

  return (
    <>
      {mnt == false && <></>}

      {mnt && (
        <ConfigProvider
          theme={{
            algorithm: antdTheme,
            token: token,
          }}
        >
          {children}
        </ConfigProvider>
      )}
    </>
  );
}
